import { render, staticRenderFns } from "./viewPHPCustom.vue?vue&type=template&id=3886d9be&scoped=true&"
import script from "./viewPHPCustom.vue?vue&type=script&lang=js&"
export * from "./viewPHPCustom.vue?vue&type=script&lang=js&"
import style0 from "./viewPHPCustom.vue?vue&type=style&index=0&id=3886d9be&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3886d9be",
  null
  
)

export default component.exports